import { api } from '../index';

const prefix = '/api/dc/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiInsertLoginIdScan(param) {
	return api.post(prefix + 'insertLoginIdScan', param);
}

export function apiSelectLoginIdList(param) {
	return api.post(prefix + 'selectLoginIdList', param);
}

export function apiUpdateAttendanceReason(param) {
	return api.post(prefix + 'updateAttendanceReason', param);
}
